var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "group_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#group_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.398 22.78q0-1.03.532-1.839.533-.81 1.422-1.259a20.6 20.6 0 0 1 3.822-1.433q1.922-.504 4.224-.504t4.225.504q1.92.504 3.822 1.433.89.45 1.421 1.26.532.808.532 1.839v.938q0 .805-.59 1.416-.592.61-1.435.61H4.424q-.843 0-1.435-.591a1.95 1.95 0 0 1-.59-1.435zm22.152 2.965q.25-.46.383-.977a4.2 4.2 0 0 0 .132-1.049v-1.102a5.2 5.2 0 0 0-.643-2.503q-.642-1.19-1.824-2.04 1.341.199 2.547.618 1.205.42 2.3.991 1.032.552 1.596 1.3a2.66 2.66 0 0 1 .562 1.634v1.102q0 .844-.59 1.435a1.95 1.95 0 0 1-1.435.59zM12.398 15.59q-1.924 0-3.295-1.37-1.371-1.372-1.371-3.297 0-1.924 1.37-3.295 1.372-1.371 3.296-1.371 1.925 0 3.296 1.37Q17.065 9 17.065 10.925q0 1.926-1.37 3.296-1.372 1.371-3.297 1.371m11.513-4.667q0 1.926-1.37 3.296-1.372 1.371-3.297 1.371-.225 0-.574-.051a5 5 0 0 1-.574-.113 7.1 7.1 0 0 0 1.212-2.104 6.9 6.9 0 0 0 .424-2.4 6.7 6.7 0 0 0-.432-2.39 7.7 7.7 0 0 0-1.204-2.111q.287-.103.574-.133.288-.03.574-.031 1.926 0 3.296 1.37Q23.911 9 23.911 10.925"
  }))));
};
export default SvgGroup;